module.exports = __webpack_public_path__ + "img/waveform.9f1ee0a3.png";